export const DATE_PARAM_FORMAT = "yyyy-MM-dd";

export const DEFAULT_PAGE_SIZE = 15;
